import { useRef, useState } from "react";
import { motion } from "framer-motion";

/**
 * Button that subtly attracts toward the cursor on hover.
 */
export default function MagneticButton({
    children,
    as = "button",
    className = "",
    strength = 0.25,
    ...props
}) {
    const ref = useRef(null);
    const [pos, setPos] = useState({ x: 0, y: 0 });

    const onMove = (e) => {
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        setPos({
            x: (e.clientX - cx) * strength,
            y: (e.clientY - cy) * strength,
        });
    };
    const onLeave = () => setPos({ x: 0, y: 0 });

    const MotionTag = motion[as] || motion.button;

    return (
        <MotionTag
            ref={ref}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            animate={{ x: pos.x, y: pos.y }}
            transition={{ type: "spring", stiffness: 200, damping: 18 }}
            className={className}
            {...props}
        >
            {children}
        </MotionTag>
    );
}
